import React from 'react'

const OnlineCreditApprovalAustin = () => {
  return (
    <>
        <section className='common-wrap online-credit-wrap'>
            <div className='container'>
                <iframe 
                    src="https://www.700dealer.com/QuickQualify/e2a09e9570ab49509d31a9d62fdd3caf-2026430" 
                    width="100%" 
                    height="1550px" 
                    frameBorder="0">
                </iframe>
            </div>
        </section>
    </>
  )
}

export default OnlineCreditApprovalAustin